import produce from 'immer';
import { panelsReducer } from "./panels";
/**
 * Responsive panels reducer.
 *
 * Data-structure looks something like this:
 *
 * {
 *   sm: {
 *     columns: {},
 *     rows: {},
 *     areas: []
 *   }
 * }
 *
 * And each reducer works on one level of the data. I'm probably
 * overabstracting here, but hey, it works.
 */

export var reducer = function reducer(state, action) {
  return produce(state, function (draft) {
    switch (action.type) {
      case 'UPDATE':
      case 'COMMIT_ALL':
        draft.initialized = true;
        draft.sm = panelsReducer(draft.sm, action);
        draft.md = panelsReducer(draft.md, action);
        draft.lg = panelsReducer(draft.lg, action);
        break;

      case 'SET_ACTIVE_BREAKPOINT':
        draft.activeBreakpoint = action.payload.breakpoint;
        break;

      default:
        draft[draft.activeBreakpoint] = panelsReducer(draft[draft.activeBreakpoint], action);
    }
  });
};